module.exports = __webpack_public_path__ + "assets/img/join2.5b8fcd64.png";